import { render, staticRenderFns } from "./ExportContacts.vue?vue&type=template&id=dd503b74&"
import script from "./ExportContacts.vue?vue&type=script&lang=js&"
export * from "./ExportContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports